module.exports = [
  ...require('./_gearRawList_r'),
  require('./rapier'),
  require('./revolver'),
  require('./rifle_automatic'),
  require('./rifle_hunting'),
]
